import Storage from './prefixedStorage'

const AUTH_TOKEN_KEY = 'token'
const AUTH_TOKEN_EXP_TIME = 'token_exp'
const AUTH_USER = 'user'

const authStore = new Storage('auth')

class Auth {
  logout () {
    this.token = null
    this.user = null
    authStore.remove(AUTH_TOKEN_EXP_TIME)
  }

  isTokenValid () {
    const now = new Date().getTime()
    const tokenExp = parseInt(this.tokenExp, 10)
    return now < tokenExp
  }

  onAuthStatusChange (cb) {
    return authStore.subscribe(AUTH_TOKEN_KEY, (token) => {
      const isAuth = Boolean(token)
      return cb(isAuth)
    })
  }

  get token () {
    return authStore.get(AUTH_TOKEN_KEY)
  }

  set token (token) {
    if (!token) {
      this.removeAuth()
      return
    }
    authStore.set(AUTH_TOKEN_KEY, token)
  }

  get tokenExp () {
    return authStore.get(AUTH_TOKEN_EXP_TIME)
  }

  set tokenExp (tokenExp) {
    if (!tokenExp) {
      this.removeAuth()
      return
    }

    return authStore.set(AUTH_TOKEN_EXP_TIME, tokenExp)
  }

  get user () {
    try {
      return JSON.parse(authStore.get(AUTH_USER))
    } catch (e) {
      console.log(e)
      return null
    }
  }

  set user (user) {
    if (!user) {
      this.removeAuth()
      return
    }
    return authStore.set(AUTH_USER, JSON.stringify(user))
  }

  removeAuth () {
    authStore.remove(AUTH_USER)
    authStore.remove(AUTH_TOKEN_EXP_TIME)
    authStore.remove(AUTH_TOKEN_KEY)
  }
}

export default new Auth()
